export default "__VITE_ASSET__B_RKMzGP__"